import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-ink pt-14" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:px-8 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <span className="font-display text-lg font-bold uppercase leading-none tracking-wide text-slate-100">
            D&amp;G Home Solutions
            <span className="block text-xs font-semibold tracking-[0.2em] text-orange-500">
              Gutters &amp; Waterproofing
            </span>
          </span>
        </div>
        <p className="mt-5 font-serif text-lg italic text-slate-400">
          "A home essential, with a taste of design."
        </p>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-500">
          Heavy-duty seamless gutters, downspouts and foundation waterproofing
          for homes across New Jersey, Delaware and Pennsylvania.
        </p>
      </div>
      <div>
        <h4 className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-orange-500">Services</h4>
        <ul className="mt-4 space-y-2 text-sm text-slate-400">
          <li>Seamless Gutters</li>
          <li>Gutter Guards</li>
          <li>Downspout Extensions</li>
          <li>Basement Waterproofing</li>
          <li>French Drains</li>
        </ul>
      </div>
      <div>
        <h4 className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-orange-500">Contact</h4>
        <ul className="mt-4 space-y-3 text-sm text-slate-400">
          <li className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-orange-500" /> (908) 956-7550
          </li>
          <li className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-orange-500" /> operations@dnghsolutions.com
          </li>
          <li className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-orange-500" /> Serving NJ · DE · PA
          </li>
        </ul>
      </div>
    </div>
    <div className="mx-auto mt-12 flex max-w-7xl flex-col items-center justify-between gap-3 border-t border-white/10 px-4 pt-6 text-xs text-slate-600 sm:flex-row sm:px-8">
      <p>© {new Date().getFullYear()} D&amp;G Home Solutions. All rights reserved.</p>
      <a href="/admin" className="transition-colors hover:text-orange-500" data-testid="footer-admin-link">
        Admin
      </a>
    </div>
    <div
      className="pointer-events-none mt-6 select-none overflow-hidden"
      aria-hidden="true"
      data-testid="footer-wordmark"
    >
      <p className="ghost-wordmark translate-y-[18%] text-center font-display text-[26vw] font-black uppercase leading-[0.75] tracking-tight md:text-[19vw]">
        D&amp;G
      </p>
    </div>
  </footer>
);
